import { CountryInput } from '@commenda/kakashi';
import { Country } from '@prisma/client';
import { MoleculeCard } from '../helpers/MoleculeCard';
import { MoleculeCardTitle } from '../helpers/MoleculeCardTitle';

type EntityIncorporationCountryDropdownProps = {
  onSelectIncorporationCountry: (country: Country) => void;
  selectedIncorporationCountry: Country | null;
  disabled?: boolean;
  error?: string;
};

export function EntityIncorporationCountryDropdown({
  onSelectIncorporationCountry,
  selectedIncorporationCountry,
  disabled = false,
  error,
}: EntityIncorporationCountryDropdownProps) {
  return (
    <MoleculeCard>
      <MoleculeCardTitle title="Incorporation country" />
      <CountryInput
        type="single"
        value={selectedIncorporationCountry}
        onValueChange={(value) => {
          if (value) {
            onSelectIncorporationCountry(value as Country);
          }
        }}
        placeholder="Select incorporation country"
        disabled={disabled}
        error={error}
      />
    </MoleculeCard>
  );
}
